/**
 * @param {*} value
 * @param {*} validationValue
 * @param {object} formAlternatives
 * @returns {boolean|boolean|*}
 */
function citizenship ({ value, validationValue, formAlternatives }) {
  if (!validationValue) return true
  if (!value || !formAlternatives) return false

  return !!formAlternatives?.citizenships?.some(c => c?.label?.toString()?.toLowerCase() === value?.toString()?.toLowerCase())
}

module.exports = { citizenship }
